import { useEffect, type ReactNode } from 'react';
import type { Session } from '../net/session';
import { SessionContext } from './context';

/** Puts one session in reach of every screen, restores it on mount, and follows other tabs' sign-outs. */
export function SessionProvider({ session, children }: { session: Session; children: ReactNode }) {
  useEffect(() => {
    // StrictMode runs this twice. The session shares one refresh, so that spends the token once.
    void session.restore();
    return session.followOtherTabs();
  }, [session]);
  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
}
